// removed by extract-text-webpack-plugin
module.exports = {"margin":"index__margin--pwZ-g"};


//////////////////
// WEBPACK FOOTER
// ./src/client/helpers/redux/styles/index.scss
// module id = a355
// module chunks = 23